<script>
	export let responses;
	export let questionset_id;
	export let question;
	export let user_language;

	let { question_id, question_text } = question;

	// a field may be "protected," meaning the HTML form field is disabled
	// this is set in Survey.svelte, based on the presence of fields in the querystring
	let protected_field = question["protected"] ? true : false;
</script>

<section>
	<div class="question_text">{question_text[user_language]}:</div>
	<input
		type="text"
		name={question_id}
		bind:value={responses[questionset_id][question_id]}
		disabled={protected_field}
	/><br />
</section>

<style>
	section {
		display: flex;
		margin-bottom: 1rem;
	}

	input {
		display: block;
	}

	.question_text {
		width: 50%;
		margin-right: 1em;
	}
</style>
